import React from "react";
import VotingBoard from "./VotingBoard";

function App() {
  return (
    <VotingBoard />
  );
}

export default App;